export { default } from "./LabelIcon";
